import { Box } from '@chakra-ui/react';
import { useTranslation } from 'helpers/languages/translations';

const DescriptionHtml = (props: { tradKey?: string; text?: string } & Record<string, any>) => {
    const translate = useTranslation();

    const { tradKey, text, ...otherProps } = props;

    return (
        <Box
            {...otherProps}
            className="textbox"
            dangerouslySetInnerHTML={{
                __html: tradKey ? (translate(tradKey) as string) : text || '',
            }}
        />
    );
};

export default DescriptionHtml;
